<template>
  <div class="flex flex-col md:flex-row gap-4">
    <table
      :class="[feesConfig.selectedPaymentMethod == 'eWallet' ? 'flex-1 w-full md:w-fit' : 'w-fit']"
      class="pt-16 table-auto border-collapse border ltr:font-sans text-xs"
    >
      <thead class="bg-brand-gray-150">
        <tr class="border border-brand-gray-300 text-start text-sm">
          <th class="py-1 px-3 border border-brand-gray-300 text-start">
            {{ $t('feesDescription') }}
          </th>
          <th colspan="2" class="py-1 px-3 border border-brand-gray-300 text-end">
            {{ $t('amount') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="bg-brand-gray-100">
          <td class="py-1.5 px-3 border border-brand-gray-300 text-start font-medium">
            {{ $t('feesTotal') }}
          </td>
          <td
            :colspan="[containsVat ? 2 : 1]"
            class="py-1.5 px-3 border border-brand-gray-300 text-end"
          >
            {{ intlNumberFormat.format(feesTotal) }}
          </td>
        </tr>
        <tr v-if="containsVat">
          <td class="py-1.5 px-3 border border-brand-gray-300 text-start font-medium">
            {{ $t('eFeescommissionVat') }}
          </td>
          <td class="py-1.5 px-3 border border-brand-gray-300 text-end">
            {{ intlNumberFormat.format(totalCommissions) }}
          </td>
          <td class="py-1.5 px-3 border border-brand-gray-300 text-end">
            {{ intlNumberFormat.format(totalCommissionsVat) }}
          </td>
        </tr>
        <tr class="bg-brand-gray-100">
          <td class="py-1.5 px-3 border border-brand-gray-300 text-start font-medium">
            {{ $t('finalTotal') }}
          </td>
          <td
            :colspan="[containsVat ? 2 : 1]"
            class="py-1.5 px-3 border border-brand-gray-300 text-end"
          >
            {{ intlNumberFormat.format(totalAmountWithCommissionsIncludingVat) }}
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="feesConfig.selectedPaymentMethod == 'eWallet'" class="flex-1 h-32">
      <Form ref="form">
        <Field name="bankAccounts" v-slot="{ field, errors: errs, handleChange }">
          <SimpleDropdown
            :field="field"
            :errors="errs"
            :label="$t('accountName')"
            :options="[
              { label: 'apple', value: 1 },
              { label: 'carrot', value: 2 }
            ]"
            :is-required="false"
            label-class="text-xs"
            input-class="w-full text-xs"
            direction="flex-col md:flex-row"
            @on-selection="(item) => handleChange(+item?.value)"
          ></SimpleDropdown>
        </Field>
      </Form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'
import { Field, Form } from 'vee-validate'

const props = defineProps({
  businessLogic: {
    type: Object,
    required: true
  },
  feesConfig: {
    type: Object,
    required: true
  }
})
const containsVat = ref()
const feesTotal = ref(0)
const totalCommissions = ref(0)
const totalCommissionsVat = ref(0)
const totalAmountWithCommissionsIncludingVat = ref(0)

const produceBusinessLogic = () => {
  props.businessLogic.map((item) => {
    containsVat.value = item.data.containsVat

    const { totalWithVat, totalAmount } = item.data
    if (item.data.containsVat) {
      feesTotal.value += totalWithVat
    } else {
      feesTotal.value += totalAmount
    }

    totalCommissions.value += item.data.totalCommissions
    totalCommissionsVat.value += item.data.totalCommissionsVat
    totalAmountWithCommissionsIncludingVat.value += item.data.totalAmountWithCommissionsIncludingVat
  })
}

// 'AE-en', { style: 'currency', currency: 'AED' }
const intlNumberFormat = Intl.NumberFormat(undefined, { maximumFractionDigits: 4 })

produceBusinessLogic()
</script>

<style lang="scss" scoped></style>
